import { Box, BoxProps } from '../Box';

export const ModalHeader = ({ css, ...rest }: BoxProps) => (
  <Box css={{ gridArea: 'header', ...css }} {...rest} />
);
